
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './Download.css'
import EnterpriseService from './../../../ApiServices/Enterprise.Service';
import { S3DownloadForEnterprise } from './../../../ApiServices/S3Bucket';
import { S3DownloadForEnterpriseQuestionnaire } from './../../../ApiServices/S3Bucket';
// import { createDownloadLogs } from './../../../ApiServices/TrustCenter';
interface Props {
    loadingTime: number;
    listType?: string;
    showDownloadPage?: boolean;
}
function Download({ loadingTime, listType, showDownloadPage }: Props) {
    const [percentage, setPercentage] = useState(0);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const selectedQuestion = useSelector((state: any) => state.AppReducer.selectedQuestion);
    const companyList = useSelector((state: any) => state.AppReducer.companyList);
    const clientDetails = useSelector((state: any) => state.AppReducer.clientDetails);

    useEffect(() => {
        let interval;
        if (loadingTime <= 1000) {
            interval = setInterval(() => {
                setPercentage((prev) => Math.min(prev + 20, 100));
            }, 200);
        } else {
            const increment = 100 / (loadingTime * 1000 / 10);
            interval = setInterval(() => {
                setPercentage((prev) => Math.min(prev + increment, 100));
            }, 10);
        }
        if (percentage > 99) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [loadingTime]);

    /**
     * Returns download filename for questionnaire Excel. Use .xlsx when source is PDF.
     */
    const getQuestionnaireDownloadFileName = (fileName: string | undefined): string => {
        if (!fileName) return 'Questionnaire_with_Answers.xlsx';
        const ext = fileName.split('.').pop()?.toLowerCase();
        if (ext === 'pdf') {
            const baseName = fileName.replace(/\.pdf$/i, '');
            return `${baseName}_with_Answers.xlsx`;
        }
        return fileName.endsWith('.xlsx') || fileName.endsWith('.xls') ? fileName : `${fileName.replace(/\.[^.]+$/, '')}_with_Answers.xlsx`;
    };

    /**
     * Initiates the download of the file associated with the selected question.
     * For questionnaire (non-document) flow: requires only bucketName and questions; uses Excel filename when source is PDF.
     */
    const downloadQuestion = async () => {
        if (listType === 'only-doument-download') {
            onFileDownload(); // Handles simple file download case
        } else {
            const company = companyList.filter((item: any) => item._id == selectedQuestion.company_id)[0];
            const fileAndFolder = company?.questionnairesFolder ?? EnterpriseService.getCompanyInfo?.questionnairesFolder;

            let questions = selectedQuestion?.questions ?? [];
            if (questions.length === 0 && selectedQuestion?.fileId && selectedQuestion?._id) {
                try {
                    const filewiseRes = await EnterpriseService.getQuestionnaireFilewise(selectedQuestion._id);
                    const detailed = filewiseRes?.data?.detailedResults;
                    const files = detailed?.files ?? [];
                    const file = files.find((f: any) => String(f._id) === String(selectedQuestion.fileId));
                    if (file?.questions?.length) questions = file.questions.map((q: any) => ({ question: q.question, answer: q.answer ?? '' }));
                } catch (e) {
                    console.error('Failed to fetch questions for download', e);
                }
            }

            const bucketName = clientDetails?.questionnairesBucket;
            if (!bucketName) {
                console.error('Missing bucket configuration for download');
                return;
            }
            if (!questions || questions.length === 0) {
                console.error('No questions available for download');
                return;
            }

            const downloadFileName = getQuestionnaireDownloadFileName(selectedQuestion?.fileName);
            const downloadObj = {
                ...selectedQuestion,
                questions,
                fileName: downloadFileName,
                fileAndFolder: fileAndFolder ?? undefined,
                bucketName,
            };

            try {
                const res = await S3DownloadForEnterpriseQuestionnaire({ obj: downloadObj });
                console.log(res, 'res');
            } catch (err) {
                console.error(err, 'err file');
            }
        }
    };

    const onFileDownload = async () => {
        let folderName:string="";
        const bucketName:string=clientDetails.complianceBucket;
        const data:any=companyList.filter((item:any)=>item._id==selectedQuestion.company_id)
        if(data && data[0]){
            folderName=data[0]?.complianceFolder;
        }

        S3DownloadForEnterprise({ fileKey: selectedQuestion?.fileId, bucketName, folderName, newFileName: selectedQuestion.fileName }).then((res: any) => {
            console.log(res, 'res');
            // createDownloadLogs([selectedQuestion.fileName], 'enterprise-apps', 'editor', true);
        }).catch((err: any) => {
            console.log(err, 'err file');
        })
    };

    /**
     * Downloads the original questionnaire file (PDF or Excel) from S3. Shown only in questionnaire flow.
     */
    const onDownloadOriginalFile = () => {
        const company = companyList.filter((item: any) => item._id == selectedQuestion.company_id)[0];
        const folderName = company?.questionnairesFolder ?? EnterpriseService.getCompanyInfo?.questionnairesFolder;
        const bucketName = clientDetails?.questionnairesBucket;
        if (!bucketName || !folderName) {
            console.error('Missing bucket or folder configuration for original file download');
            return;
        }
        if (!selectedQuestion?.fileId || !selectedQuestion?.fileName) {
            console.error('Missing file id or file name for original file download');
            return;
        }
        S3DownloadForEnterprise({
            fileKey: selectedQuestion.fileId,
            bucketName,
            folderName,
            newFileName: selectedQuestion.fileName,
        })
            .then((res: any) => console.log(res, 'res'))
            .catch((err: any) => console.error(err, 'err file'));
    };

    const radius = 40; // Radius of the circle
    const strokeWidth = 8; // Stroke width of the circle
    const circumference = 2 * Math.PI * radius; // Calculate circumference

    // Calculate the stroke-dashoffset based on the percentage
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    const totalQuestion = `${(selectedQuestion && selectedQuestion.questions ? (selectedQuestion.questions.length) : 0)}`;
    return (
        <div className="right-wrapper">
            {/* circle loader start */}
            <svg className="circle-loader" width={radius * 2} height={radius * 2}>
                <circle
                    className="circle-loader-background"
                    cx={radius}
                    cy={radius}
                    r={radius - strokeWidth / 2}
                    strokeWidth={strokeWidth}
                />
                <circle
                    className="circle-loader-progress"
                    cx={radius}
                    cy={radius}
                    r={radius - strokeWidth / 2}
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                />
                <text className="circle-loader-text text-white" x={radius} y={radius}>{percentage}%</text>
            </svg>
            {/* circle loader end */}

            <div>
                <div className='mb-2'>Targhee Secure AI</div>
                <div>Processing Complete</div>
            </div>

            {listType != 'only-doument-download' ? (
                <>
                <h2 className='my-3'>
                    <span>
                        <span className='text-primary'> {totalQuestion}</span>
                        /{totalQuestion} Questions Answered!
                    </span>
                </h2>

                <div className="mb-3">
                    <p>We were able to find answers for {totalQuestion}/{totalQuestion} questions.</p>
                    <p>You can review and edit the answers in the next step.</p>
                </div>
                <button className="suggestions-button">
                    <img src={process.env.PUBLIC_URL + 'assets/imgs/bulb.png'} alt="bulb" style={{ width: '20px', marginRight: '8px' }} />
                    <span>{totalQuestion} suggestions</span>
                </button>
                <div style={{ height: '1px', width: '180px', background: 'black', marginTop: '24px', marginBottom: '24px' }} />
                <div className="incomplete-container">
                    <img src={process.env.PUBLIC_URL + 'assets/imgs/circle-half.png'} alt="half-circle" style={{ width: '28px', marginRight: '4px' }} />
                    <span>0 incomplete</span>
                </div>
                </>
            ) : null}
            
            <div className="buttons-container">
                {listType != 'only-doument-download' ? (
                    <button className="review-button" onClick={() => {
                        navigate(`/enterprise-review/${selectedQuestion?.fileName ? selectedQuestion?.fileName : ''}`)
                    }}>
                        Review Answers
                    </button>
                ) : null}

                <button className="download-button" onClick={() => downloadQuestion()}>
                    Download Answers
                </button>

                {listType != 'only-doument-download' ? (
                    <button className="download-button" onClick={onDownloadOriginalFile}>
                        Download Original File
                    </button>
                ) : null}
            </div>
        </div>
    )
}

export default Download